$('select[name="search_studentid"]').change(function () {
    window.location = base_url + 'eportfolio/students/report/?student=' + $(this).val();
});
